export const DEVICE_OS_QUERY_PARAM: string = 'device_os';

export const DEVICE_OS_COOKIE: string = 'device_os';
